import { render } from "./vipClub.vue?vue&type=template&id=c2e2c6d2"
import script from "./vipClub.vue?vue&type=script&lang=js"
export * from "./vipClub.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__